<template>
  <section class="space-y-5">
    <header>
      <h2 class="text-lg font-semibold text-gray-900">Hero</h2>
      <p class="text-sm text-gray-500">
        Top of the foundation page. Appears above the campaign progress card.
      </p>
    </header>

    <div>
      <label class="mb-1 block text-sm font-medium text-gray-700">Badge (eyebrow)</label>
      <input
        v-model="content.badge"
        type="text"
        maxlength="120"
        class="w-full rounded-md border-gray-300 text-sm focus:border-pink-500 focus:ring-pink-500"
        placeholder="Dig Pink® Campaign"
      >
    </div>

    <div>
      <label class="mb-1 block text-sm font-medium text-gray-700">Headline</label>
      <input
        v-model="content.headline"
        type="text"
        maxlength="250"
        class="w-full rounded-md border-gray-300 text-sm focus:border-pink-500 focus:ring-pink-500"
        placeholder="More Research. More Answers. More Tomorrows."
      >
    </div>

    <TemplateRichTextInput
      v-model="content.body"
      label="Body"
      help-text="Supporting paragraph shown below the headline on the hero. Supports basic formatting."
      :max-length="3000"
    />

    <TemplateImageInput
      v-model="content.background_image"
      :upload-url="uploadUrl"
      subfolder="hero"
      label="Background image"
      help-text="Large image behind the hero. Tall aspect works best. Fallback falls back to the campaign's hero_image_path."
    />
  </section>
</template>

<script>
import TemplateImageInput from '../TemplateImageInput.vue';
import TemplateRichTextInput from '../TemplateRichTextInput.vue';

export default {
  name: 'HeroSectionEditor',
  components: { TemplateImageInput, TemplateRichTextInput },
  props: {
    content: { type: Object, required: true },
    uploadUrl: { type: String, required: true },
  },
};
</script>
